import React, { useState, useEffect } from "react";
import "./VincularContasMeta.css";

function VincularContasMeta() {
  const [usuarios, setUsuarios] = useState([]);
  const [paginas, setPaginas] = useState([]);
  const [adAccounts, setAdAccounts] = useState([]);
  const [instagrams, setInstagrams] = useState([]);
  const [formData, setFormData] = useState({
    usuario_id: "",
    facebook_page_id: "",
    facebook_page_name: "",
    instagram_id: "",
    instagram_username: "",
    ad_account_id: "",
    ad_account_name: "",
    tipo_pagamento: "pre",

  });
  

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [vinculo, setVinculo] = useState(null);
  const [listando, setListando] = useState(false);

  const [searchUsuario, setSearchUsuario] = useState("");
  const [searchPagina, setSearchPagina] = useState("");
  const [searchInstagram, setSearchInstagram] = useState("");
  const [searchAdAccount, setSearchAdAccount] = useState("");


  useEffect(() => {
    carregarUsuarios();
    carregarPaginas();
    carregarAdAccounts();
    carregarInstagrams();
  }, []);

  const carregarUsuarios = async () => {
    try {
      const response = await fetch("https://welaunchyou.com.br/crm-wly/listagem_usuarios.php", {
        credentials: "include",
      });
      const data = await response.json();
      if (data.usuarios) setUsuarios(data.usuarios);
    } catch (error) {
      console.error("Erro ao carregar usuários:", error);
    }
  };

  const carregarPaginas = async () => {
    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/api/integracoes/meta_listar_paginas.php",
        { credentials: "include" }
      );
      const data = await response.json();
      if (data.success) setPaginas(data.data || []);
    } catch (error) {
      console.error("Erro ao carregar páginas:", error);
    }
  };

  const carregarAdAccounts = async () => {
    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/api/integracoes/meta_listar_adaccounts.php",
        { credentials: "include" }
      );
      const data = await response.json();
      if (data.success) setAdAccounts(data.data || []);
    } catch (error) {
      console.error("Erro ao carregar contas de anúncios:", error);
    }
  };

  const carregarInstagrams = async () => {
    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/api/integracoes/meta_listar_instagram.php",
        { credentials: "include" }
      );
      const data = await response.json();
      if (data.success) setInstagrams(data.data || []);
    } catch (error) {
      console.error("Erro ao carregar perfis Instagram:", error);
    }
  };

  const carregarVinculo = async () => {
    setListando(true);
    setVinculo(null);
    setError("");
    setMessage("");

    if (!formData.usuario_id) {
      setError("Selecione um usuário para listar o vínculo.");
      setListando(false);
      return;
    }

    try {
      const response = await fetch(
        `https://welaunchyou.com.br/crm-wly/api/integracoes/meta_listar_vinculo.php?usuario_id=${formData.usuario_id}`,
        { credentials: "include" }
      );
      const data = await response.json();
      if (data.success) {
        if (data.data) {
          setVinculo(data.data);
        } else {
          setVinculo(null);
          setMessage("Nenhum vínculo encontrado para este usuário.");
        }
      } else {
        setError(data.error || "Erro ao buscar vínculo.");
      }
    } catch (err) {
      console.error("Erro ao carregar vínculo:", err);
      setError("Erro ao conectar ao servidor.");
    } finally {
      setListando(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "facebook_page_id") {
      const paginaSelecionada = paginas.find(p => p.id.toString() === value);
      setFormData((prev) => ({
        ...prev,
        facebook_page_id: value,
        facebook_page_name: paginaSelecionada ? paginaSelecionada.name : "",
      }));
    } else if (name === "ad_account_id") {
      const contaSelecionada = adAccounts.find(a => a.id.toString() === value);
      setFormData((prev) => ({
        ...prev,
        ad_account_id: value,
        ad_account_name: contaSelecionada ? contaSelecionada.name : "",
      }));
    } else if (name === "instagram_id") {
      const instaSelecionado = instagrams.find(i => i.ig_id.toString() === value);
      setFormData((prev) => ({
        ...prev,
        instagram_id: value,
        instagram_username: instaSelecionado ? instaSelecionado.username : "",
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
    
  
    setVinculo(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    try {
      const response = await fetch(
        "https://welaunchyou.com.br/crm-wly/api/integracoes/meta_salvar_vinculo.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();
      if (response.ok) {
        setMessage("Vínculo salvo com sucesso!");
      } else {
        setError(data.error || "Erro ao salvar vínculo.");
      }
    } catch (err) {
      setError("Erro ao se conectar ao servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cadastro">
      <h1>Vincular Contas Meta</h1>
      <div className="main-container">
        <div className="cadastro-lead-container">
          {message && <p className="success-message">{message}</p>}
          {error && <p className="error-message">{error}</p>}
  
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="usuario_id">Usuário:</label>
              <input
                type="text"
                placeholder="Pesquisar usuário..."
                value={searchUsuario}
                onChange={(e) => setSearchUsuario(e.target.value)}
              />
              <select
                id="usuario_id"
                name="usuario_id"
                value={formData.usuario_id}
                onChange={handleChange}
                required
              >
                <option value="">Selecione um usuário</option>
                {usuarios
  .filter((usuario) =>
    usuario.nome_empresa &&
    usuario.nome_empresa.toLowerCase().includes(searchUsuario.toLowerCase())
  )
  .map((usuario) => (
    <option key={usuario.id} value={usuario.id}>
      {usuario.nome_empresa}
    </option>
))}

              </select>
            </div>
  
            <div className="form-group">
              <label htmlFor="facebook_page_id">Página do Facebook:</label>
              <input
                type="text"
                placeholder="Pesquisar página..."
                value={searchPagina}
                onChange={(e) => setSearchPagina(e.target.value)}
              />
              <select
                id="facebook_page_id"
                name="facebook_page_id"
                value={formData.facebook_page_id}
                onChange={handleChange}
                required
              >
                <option value="">Selecione uma página</option>
                {paginas
                  .filter((pagina) =>
                    pagina.name.toLowerCase().includes(searchPagina.toLowerCase())
                  )
                  .map((pagina) => (
                    <option key={pagina.id} value={pagina.id}>
                      {pagina.name}
                    </option>
                  ))}
              </select>
            </div>
  
            <div className="form-group">
              <label htmlFor="instagram_id">Perfil do Instagram:</label>
              <input
                type="text"
                placeholder="Pesquisar Instagram..."
                value={searchInstagram}
                onChange={(e) => setSearchInstagram(e.target.value)}
              />
              <select
                id="instagram_id"
                name="instagram_id"
                value={formData.instagram_id}
                onChange={handleChange}
                required
              >
                <option value="">Selecione um perfil</option>
                {instagrams
                  .filter((insta) =>
                    insta.username.toLowerCase().includes(searchInstagram.toLowerCase())
                  )
                  .map((insta) => (
                    <option key={insta.ig_id} value={insta.ig_id}>
                      {insta.username}
                    </option>
                  ))}
              </select>
            </div>
  
            <div className="form-group">
              <label htmlFor="ad_account_id">Conta de Anúncios:</label>
              <input
                type="text"
                placeholder="Pesquisar conta de anúncios..."
                value={searchAdAccount}
                onChange={(e) => setSearchAdAccount(e.target.value)}
              />
              <select
                id="ad_account_id"
                name="ad_account_id"
                value={formData.ad_account_id}
                onChange={handleChange}
                required
              >
                <option value="">Selecione uma conta</option>
                {adAccounts
                  .filter((account) =>
                    account.name.toLowerCase().includes(searchAdAccount.toLowerCase())
                  )
                  .map((account) => (
                    <option key={account.id} value={account.id}>
                      {account.name}
                    </option>
                  ))}
              </select>
            </div>

            <div className="form-group">
  <label htmlFor="tipo_pagamento">Tipo de Pagamento:</label>
  <select
    id="tipo_pagamento"
    name="tipo_pagamento"
    value={formData.tipo_pagamento}
    onChange={handleChange}
    required
  >
    <option value="pre">Pré-pago</option>
    <option value="pos">Pós-pago (Cartão)</option>
  </select>
</div>

  
            <button className="btn-vincular" type="submit" disabled={loading}>
              {loading ? "Salvando..." : "Salvar Vínculo"}
            </button>
          </form>
  
          <button
            type="button"
            className="listar-button"
            onClick={carregarVinculo}
            disabled={listando}
          >
            {listando ? "Carregando vínculo..." : "Listar Vínculo"}
          </button>
  
          {vinculo && (
            <div className="vinculo-card">
              <h3>Vínculo Atual</h3>
              <p><strong>Página Facebook:</strong> {vinculo.facebook_page_name || '—'}</p>
              <p><strong>Conta de Anúncios:</strong> {vinculo.ad_account_name || '—'}</p>
              <p><strong>Instagram:</strong> {vinculo.instagram_username || '—'}</p>
              <p><strong>Data de Vínculo:</strong> {vinculo.created_at || '—'}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );  
}

export default VincularContasMeta;
